/*  スライダー
----------------------------------------- */
$('.slider').slick({
	dots: false,
	infinite: true,
	arrows: false,
	speed: 300,
	slidesToShow: 3,
	slidesToScroll: 1,
	centerMode: true,
	centerPadding: '40px',
	responsive: [
		{
			breakpoint: 960,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				infinite: true,
				dots: true
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true
			}
		}
	]
});

$('.daigaku_lp_slide01').slick({
	dots: false,
	infinite: true,
	arrows: false,
	autoplay: true,
	autoplaySpeed: 0,
	cssEase: 'linear',
	speed:  8000,
	slidesToShow: 6,
	slidesToScroll: 1,
	centerMode: true,
	centerPadding: '40px',
	responsive: [
		{
			breakpoint: 960,
			settings: {
				slidesToShow: 4
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 2
			}
		}
	]
});

$('.daigaku_lp_slide02').slick({
	dots: false,
	infinite: true,
	arrows: false,
	autoplay: true,
	autoplaySpeed: 0,
	speed:  8000,
	cssEase: 'linear',
	slidesToShow: 6,
	slidesToScroll: 1,
	centerMode: true,
	centerPadding: '40px',
	rtl: true,
	responsive: [
		{
			breakpoint: 960,
			settings: {
				slidesToShow: 4
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 2
			}
		}
	]
});